import { render, staticRenderFns } from "./DragAndDropNotice.vue?vue&type=template&id=3920de03&scoped=true"
import script from "./DragAndDropNotice.vue?vue&type=script&lang=ts"
export * from "./DragAndDropNotice.vue?vue&type=script&lang=ts"
import style0 from "./DragAndDropNotice.vue?vue&type=style&index=0&id=3920de03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920de03",
  null
  
)

export default component.exports